import React, {useEffect, useState} from "react";
import {Card, Form, InputGroup, Row} from "react-bootstrap";
import { Link, useLocation } from "react-router";
import { useDispatch } from "react-redux";
import { login, authentication_error, dismiss_error, dismiss_success } from "../_redux/_actions/authentication.actions";
import LogoHeader from "./Components/LogoHeader/logo_header";
// import aafpLogo from "../images/AAFP_logo.png";
// import prismaLogo from "../images/prismaLogo.png";
// import stjudeLogo from "../images/stjude.png";
import styles from "./login_page.module.scss";
import { isValidEmail, isSingleSignOnEmail } from "../_helpers/misc_functions";
import ErrorMessage from "./ErrorMessage";
import SuccessMessage from "./SuccessMessage";
import SubmitButton from "./SubmitButton";
import { useNavigate } from "react-router";
import HubspotSupportWidget from "../MainPage/HubspotSupportWidget";
import clsx from "clsx";
import {FaEnvelope, FaLock} from "react-icons/fa";

const LoginPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const prefilled_code = params.get('code') ?? '';
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [firstLogin, ] = useState(params.get('first_login'));

  // Check if the query param "code" exists
  const hasCodeQueryParam = prefilled_code.trim() !== '';

  // Check if the last page (if you're storing it) was '/register'
  // Adjust the property name based on how you pass this info (e.g. lastPath or from)
  const cameFromRegister = location.state?.lastPath === 'register';

  // Determine if the registration link should be shown
  const showRegistrationLink = hasCodeQueryParam || cameFromRegister;

  const [email, setEmail] = useState(params.get('email') ?? '');
  const [redirectPathname,] = useState(params.get('redirect_url'))
  const [password, setPassword] = useState('');

  if (params.get('error')) dispatch(authentication_error(params.get('error')));
  const forgotPasswordLocation = Object.assign({}, location, { pathname: '/forgot-password', search: params.toString() })
  const singleSignOnLocation = Object.assign({}, location, { pathname: '/single-sign-on', search: params.toString() })
  // const registerLocation = Object.assign({}, location, { pathname: '/register', search: params.toString() })

  useEffect(() => {
    return () => {
      dispatch(dismiss_error());
      dispatch(dismiss_success());
    };
  }, [dispatch]);

  const handleEmailChange = e => {
    setEmail(e.target.value);
  }

  const handlePasswordChange = e => {
    setPassword(e.target.value);
  }

  const handleSubmit = async event => {
    event.preventDefault();

    if (!isValidEmail(email)) {
      authentication_error("Please enter valid email address.");
      return;
    }

    if (isSingleSignOnEmail(email)) {
      authentication_error("Please login through SSO");
      navigate(singleSignOnLocation);
      return;
    }

    // remove redirect_url from being included in redirect_search (aka the query params after login)
    delete params.delete('redirect_url');
    const redirectSearch = params.toString();

    const redirectLocation = Object.assign(
      {},
      location,
      {
        pathname: redirectPathname ?? '/',
        search: redirectSearch
      });
    dispatch(login({ email, password }, redirectLocation));
  };

  return (
    <Card className={styles.container}>
      <HubspotSupportWidget layout="fixed-layout" />
      <LogoHeader />
      {firstLogin ? (
        <Row className={clsx(styles.headerInstructions, "mb-2")}>
          <p>LOGIN: STEP 1 OF 3</p>
          <p className={clsx('mb-1', styles.loginHeader)}>Login to access inspirational<br />microlearnings</p>
          <p>Just two more steps and you're finished!</p>
        </Row>
      ) : <Row className={clsx(styles.loginHeaderContainer)}>
      </Row>}


      <div className={styles.inputContainer}>
        <Form
          className={`d-flex flex-column align-items-center ${styles.form}`}
          onSubmit={handleSubmit}
        >
          <ErrorMessage />
          <SuccessMessage />
          <Form.Group className={clsx(styles.formGroup, 'mt-3')} controlId="email">
            <InputGroup>
              <InputGroup.Text id="inputGroupPrepend"><FaEnvelope /></InputGroup.Text>
              <Form.Control
                autoFocus
                type="email"
                value={email}
                onChange={handleEmailChange}
                className={styles.formInput}
                placeholder={"Email"}
              />
            </InputGroup>
          </Form.Group>
          <Form.Group className={clsx(styles.formGroup, "mt-3")} controlId="password">
            <InputGroup>
              <InputGroup.Text id="inputGroupPrepend"><FaLock /></InputGroup.Text>
              <Form.Control
                value={password}
                onChange={handlePasswordChange}
                type="password"
                placeholder={"Password"}
                className={styles.formInput}
              />
            </InputGroup>
          </Form.Group>
          <div className={clsx("mb-5 mt-4", styles.forgotPasswordContainer)}>
            <Link to={forgotPasswordLocation} className={styles.forgotPasswordLink}>
              {"Forgot your password"}
            </Link>
            <span className="mx-2">|</span>
            <Link to={singleSignOnLocation} className={styles.forgotPasswordLink}>
              {"Login with SSO"}
            </Link>
          </div>
          <SubmitButton text={"LOGIN"} role={'login'} pendingText={"Logging In..."} />
        </Form>
      </div>

      {
        showRegistrationLink &&
        <>
          <div style={{ textAlign: 'center' }}>{"Don't have an account?"}</div>
          <Link
            to={Object.assign({}, location, { pathname: '/register' })}
            className={styles.forgotPasswordLink} style={{ marginTop: '0' }}
          >
            {"Click here to Register."}
          </Link>
        </>
      }
    </Card>
  );
}

export default LoginPage;